import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateDriverConfigMutationVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
  config: Types.Scalars['jsonb']['input'];
}>;


export type UpdateDriverConfigMutation = { __typename?: 'mutation_root', init_null_config?: { __typename?: 'drivers_mutation_response', affected_rows: number } | null, update_drivers?: { __typename?: 'drivers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'drivers', id: number, config?: object | null }> } | null };


export const UpdateDriverConfigDocument = gql`
    mutation UpdateDriverConfig($driverId: bigint!, $config: jsonb!) {
  init_null_config: update_drivers(
    where: {id: {_eq: $driverId}, config: {_is_null: true}}
    _set: {config: {}}
  ) {
    affected_rows
  }
  update_drivers(where: {id: {_eq: $driverId}}, _append: {config: $config}) {
    affected_rows
    returning {
      id
      config
    }
  }
}
    `;
export type UpdateDriverConfigMutationFn = Apollo.MutationFunction<UpdateDriverConfigMutation, UpdateDriverConfigMutationVariables>;

/**
 * __useUpdateDriverConfigMutation__
 *
 * To run a mutation, you first call `useUpdateDriverConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverConfigMutation, { data, loading, error }] = useUpdateDriverConfigMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateDriverConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverConfigMutation, UpdateDriverConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverConfigMutation, UpdateDriverConfigMutationVariables>(UpdateDriverConfigDocument, options);
      }
export type UpdateDriverConfigMutationHookResult = ReturnType<typeof useUpdateDriverConfigMutation>;
export type UpdateDriverConfigMutationResult = Apollo.MutationResult<UpdateDriverConfigMutation>;
export type UpdateDriverConfigMutationOptions = Apollo.BaseMutationOptions<UpdateDriverConfigMutation, UpdateDriverConfigMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (init_null_config, update_drivers): returns the full response object.
 * @source {@link src/features/drivers/queries/updateDriverConfig.mutation.gql}
 */
export async function updateDriverConfig(
  variables: UpdateDriverConfigMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<UpdateDriverConfigMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<UpdateDriverConfigMutation>(
    UpdateDriverConfigDocument,
    variables,
    requestOptions
  )
}